import { render, staticRenderFns } from "./tab.vue?vue&type=template&id=3d1060f3"
import script from "./tab.vue?vue&type=script&lang=js"
export * from "./tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports